import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatRp, imgUrl } from "@/lib/api";
import { ProductDescription } from "@/pages/ProductDetail";

export const PreviewDialog = ({ open, onOpenChange, form, categoryName }) => {
  const finalPrice = Math.round((form.price * (100 - (form.discount_percent || 0))) / 100);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-3xl" data-testid="product-preview-dialog">
        <DialogHeader><DialogTitle>Pratinjau tampilan di toko</DialogTitle></DialogHeader>
        <div className="grid gap-6 md:grid-cols-2">
          <img src={imgUrl(form.images[0])} alt="" className="aspect-square w-full rounded-lg border border-stone-200 object-cover" />
          <div>
            <p className="text-sm text-stone-500">{categoryName}</p>
            <h2 className="text-2xl font-semibold">{form.name || "(tanpa nama)"}</h2>
            <p className="tnum mt-2 text-xl font-semibold text-amber-800">{formatRp(finalPrice)}
              {form.discount_percent > 0 && <span className="ml-2 text-sm font-normal text-stone-400 line-through">{formatRp(form.price)}</span>}</p>
            {form.short_description && <p className="mt-3 text-sm text-stone-600">{form.short_description}</p>}
            <p className="mt-2 text-sm">Stok: {form.stock}</p>
            <div className="mt-4"><ProductDescription html={form.description} /></div>
          </div>
        </div>
        <p className="text-xs text-stone-500">Status saat ini: <b>{form.status}</b>. Produk hanya tampil di toko jika status Published.</p>
      </DialogContent>
    </Dialog>
  );
};
